import React, { useCallback, useRef, useState } from 'react';
import { Button, Container } from 'reactstrap';
import { connect } from 'react-redux';

import {
  AsyncTableInfinite, ConfirmationModal, Intl, AudioModal, FavouriteUploadAudioModal,
} from 'components';
import { handlePromise } from 'utils';
import ListPhoneNumbersService from 'api/ListPhoneNumbers';
import SettingsActions from 'store/reducers/Settings';

const Favourite = ( {
  data, isLoading, onFetchData, onReloadData, onDelete, toggleErrorAlert, toggleLoading,
} ) => {
  const [deleteModal, setDeleteModal] = useState( false );
  const [audioModal, setAudioModal] = useState( false );
  const [uploadAudioModal, setUploadAudioModal] = useState( false );
  const toDeleteIdRef = useRef( null );
  const audioRef = useRef( null );

  const downloadFavorite = useCallback(
    async ( id ) => {
      console.log(id,'id');
      toggleLoading( true );
      const [errors, response, responseData] = await handlePromise(
        ListPhoneNumbersService.exportFavorite( id ),
      );
      toggleLoading( false );
      if ( !response.ok ) return toggleErrorAlert( errors );
      window.open( responseData.url );
    },
    [toggleLoading, toggleErrorAlert],
  );

  const toggleDeleteModal = useCallback( ( id ) => {
    toDeleteIdRef.current = id;
    setDeleteModal( ( state ) => !state );
  }, [] );

  const toggleAudioModal = useCallback( ( audio ) => {
    audioRef.current = audio;
    setAudioModal( ( state ) => !state );
  }, [] );

  const toggleUploadAudioModal = useCallback( () => {
    setUploadAudioModal( ( state ) => !state );
  }, [] );

  console.log('data====>', data)
  return (
    <>
      <Container fluid className="mt-3">
        <AsyncTableInfinite
          data={data.data}
          total={data.total}
          isLoading={isLoading}
          onFetchData={onFetchData}
          defaultSortBy={[{ id: 'createdAt', desc: true }]}
          titleContent={<Intl id="audioFilesList" />}
          rightContent={(
            <Button color="app-default" size="app-sm" onClick={toggleUploadAudioModal}>
              <Intl id="uploadFile" />
            </Button>
          )}
          columns={[
            {
              Header: 'audioFileName',
              accessor: 'userDefineAudioName',
              style: { textAlign: 'left', paddingLeft: 20 },
              Cell: ( { cell } ) => (
                cell.value
                  ? (
                    <span className="text-mp-blue-1" style={{ cursor: 'pointer' }} onClick={() => toggleAudioModal( cell.row.original )}>
                      {cell.value}
                    </span>
                  ) : '-'
              ),
            },
            {
              accessor: 'id',
              disableSorting: true,
              width: 20,
              Header: '',
              Cell: ( { cell } ) => (
                <>
                  <Button
                    rel="noopener noreferrer"
                    className="p-0 lh-110 btn-outline-link mr-3"
                    onClick={() => {
                      downloadFavorite( cell.value );
                    }}
                    // target="_blank"
                    // href={cell.row.original.uri}
                  >
                    &nbsp;&nbsp;&nbsp;
                    <Intl id="download" />
                  </Button>
                  <Button
                    color="outline-link"
                    className="p-0 lh-110"
                    onClick={() => {
                      toggleDeleteModal( cell.value );
                    }}
                  >
                    <Intl id="delete" />
                  </Button>
                </>
              ),
            },
          ]}
          headerWidth={['col-8', 'col']}
          minRows={14}
        />
      </Container>

      {deleteModal
      && (
        <ConfirmationModal
          open={deleteModal}
          title="deleteModalFile.confirmation"
          onConfirm={() => onDelete( toDeleteIdRef.current, toggleDeleteModal )}
          onClose={toggleDeleteModal}
        />
      )}

      {audioModal
      && (
        <AudioModal
          uri={audioRef.current ? audioRef.current.uri : null}
          modalTitle={audioRef.current.originalName}
          open={audioModal}
          onClose={toggleAudioModal}
        />
      )}

      {uploadAudioModal
      && (
        <FavouriteUploadAudioModal
          open={uploadAudioModal}
          onClose={toggleUploadAudioModal}
          onReload={() => {
            toggleUploadAudioModal();
            onReloadData();
          }}
        />
      )}
    </>
  );
};

const mapDispatchToProps = {
  toggleLoading: SettingsActions.toggleLoading,
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
};

export default connect( null, mapDispatchToProps )( Favourite );